<section class="wrapper">
    <form [formGroup]="form">
        <header>
            <div class="breadcrumb">
                <span class="icon icon-caret-left"></span>
                <div class="breadcrumb-link" (click)="goBack()">
                    <span>{{ 'pages.collections.configuration.header.breadcrumb' | translate }}</span>
                </div>
            </div>
            <h1> {{ title }}</h1>
        </header>
        <section class="content loading" *ngIf="loading">
            <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        </section>
        <section class="content">
            <h2>{{ 'pages.collections.configuration.form.sections.general-information.title' | translate }}</h2>
            <div class="section-content section-general-information">
                <div class="translation-inputs-name" formGroupName="name">
                    <div *ngFor="let language of langs" class="lang-input-wrapper">
                        <app-form-input
                            [label]="'pages.collections.configuration.form.sections.general-information.name.label.' + language | translate"
                            [placeholder]="'pages.collections.configuration.form.sections.general-information.name.placeholder.' + language | translate"
                            [formControlName]="language"
                        >
                            <app-form-error *ngIf="nameForm.get(language).touched && nameForm.get(language).hasError('required')">
                                {{ 'pages.collections.configuration.form.sections.general-information.name.errors.required' | translate }}
                            </app-form-error>
                        </app-form-input>
                    </div>
                </div>
            </div>

            <div class="section-content section-color-icon">
                <app-bciti-color-select
                class="input-color"
                formControlName="color"
                [colors]="colorsList"
                [width]="'105px'"
              ></app-bciti-color-select>
              <app-bciti-icon-select
                class="input-color"
                formControlName="icon"
                [icons]="iconsList"
                [width]="'105px'"
              ></app-bciti-icon-select>
              <app-bciti-shape-select
                formControlName="minifiedShape"
                [shapes]="minifiedShapesList"
                [width]="'105px'"
              ></app-bciti-shape-select>
            </div>

            <div class="section-content section-areas">
                <div class="areas-select-container" *ngIf="areas$ | async as areas">
                    <app-form-select-multiple
                        [label]="'pages.collections.configuration.form.sections.areas.label' | translate"
                        formControlName="areas"
                        [options]="areas"
                        [displayAddArea]="true"
                    >
                        <app-form-error *ngIf="areasForm.touched && areasForm.hasError('required')">
                            {{ 'pages.collections.configuration.form.sections.areas.errors.required' | translate }}
                        </app-form-error>
                    </app-form-select-multiple>
                    <mat-chip-list #chipList aria-label="selection" class="aeras-selected">
                        <div *ngFor="let area of form.controls.areas.value">
                            <mat-chip (removed)="removeArea(area)">
                                <span>{{area.name[currentLang]}}</span>
                                <button class="area-chip-remove" mat-icon-button matChipRemove>
                                    <span class="icon-close icon-close-color"></span>
                                </button>
                            </mat-chip>
                        </div>
                    </mat-chip-list>
                </div>
            </div>

            <h2>{{ 'pages.collections.configuration.form.sections.default-schedule.title' | translate }}</h2>
            <div class="section-content section-default-schedule">
                <app-collection-schedule
                    #defaultSchedule
                    formControlName="defaultSchedule"
                    [optionsFrequencies]="frequencies"
                    [optionsDays]="days"
                    [hasBorder]="false"
                    [endDateIsRequired]="false"
                ></app-collection-schedule>
            </div>

            <h2>{{ 'pages.collections.configuration.form.sections.custom-schedule.title' | translate }}</h2>
            <span class="section-infos">{{ 'pages.collections.configuration.form.sections.custom-schedule.infos' | translate }}</span>
            <div class="section-content section-custom-schedule">
                <button type="button" class="save-button bciti-button bciti-button--blue-inversed" (click)="startCreatingCustomSchedule()">
                    {{ 'pages.collections.configuration.form.sections.custom-schedule.button' | translate }}
                </button>

                <div formGroupName="customSchedules">
                    <app-collection-schedule
                        #customSchedule
                        *ngFor="let customSchedulesId of customSchedulesIds"
                        [formControlName]="customSchedulesId"
                        [optionsFrequencies]="frequencies"
                        [optionsDays]="days"
                        [closeable]="true"
                        [id]="customSchedulesId"
                         (cancelCreate)="handleCancelCreate($event)"
                    ></app-collection-schedule>
                </div>
            </div>
        </section>
        <footer *ngIf="!loading">
            <div class="row action-button">
                <button class="bciti-button bciti-button--blue-inversed action-button" (click)="goBack()">{{ 'pages.collections.configuration.form.cancel' | translate }}</button>
                <button
                    (click)="saveCollection()"
                    class="bciti-button bciti-button--blue action-button" 
                    [disabled]="submitLoading">
                        <mat-progress-spinner
                            *ngIf="submitLoading"
                            mode="indeterminate" 
                            diameter="20"
                        ></mat-progress-spinner>
                        <span  *ngIf="!submitLoading">
                            {{ 'pages.collections.configuration.form.save' | translate }}
                        </span>
                </button>
            </div>
        </footer>
    </form>
</section>